/**
 * Canonical list of allowed Bridebook domains for short link creation and resolution.
 * Used by both `isValidTargetUrl` (creation-side prefix check) and
 * `isSafeRedirectUrl` (redirect-side hostname check).
 */
export const ALLOWED_DOMAINS = [
  'bridebook.com',
  'www.bridebook.com',
  'bridebook.co.uk',
  'www.bridebook.co.uk',
] as const;

export const ALLOWED_URL_PREFIXES = ALLOWED_DOMAINS.map((d) => `https://${d}`);

export const DEV_DOMAIN_PATTERNS = ['vercel.app', 'ngrok', 'trycloudflare.com'];
